<template>
  <div>
    <Navbar />
    <section class="section">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <article class="content">
              <div class="content__header">
                <h1><strong>{{$t('faq')}}</strong></h1>
              </div>
                <div>{{$t('inDevelop')}}</div>
            </article>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/views/landing/Navbar.vue'
import Footer from '@/views/landing/Footer.vue'

export default {
  name: 'faq',
  components: {
    Footer,
    Navbar
  }
}
</script>
